import React from 'react';

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const DashboardIcon = () => (
  <svg {...base}><rect x="3.5" y="3.5" width="7" height="7" rx="1.5" /><rect x="13.5" y="3.5" width="7" height="7" rx="1.5" /><rect x="3.5" y="13.5" width="7" height="7" rx="1.5" /><rect x="13.5" y="13.5" width="7" height="7" rx="1.5" /></svg>
);

export const MemberIcon = () => (
  <svg {...base}><circle cx="12" cy="8" r="3.4" /><path d="M4.5 20c1.4-3.6 4.2-5.5 7.5-5.5s6.1 1.9 7.5 5.5" /></svg>
);

export const AccountIcon = () => (
  <svg {...base}><circle cx="9" cy="9" r="3" /><path d="M3.5 19c1-2.8 3-4.3 5.5-4.3S13.5 16.2 14.5 19" /><path d="M16 8h4.5M16 12h4.5" /></svg>
);

export const MenuIcon = () => (
  <svg {...base}><path d="M4 6h16M4 12h16M4 18h10" /></svg>
);

export const CodeIcon = () => (
  <svg {...base}><path d="M9 8 5 12l4 4M15 8l4 4-4 4" /></svg>
);

export const NoticeIcon = () => (
  <svg {...base}><path d="M5 4.5h11l3 3V19a.5.5 0 0 1-.5.5H5.5A.5.5 0 0 1 5 19V4.5Z" /><path d="M9 10h6M9 13.5h6" /></svg>
);

export const HistoryIcon = () => (
  <svg {...base}><circle cx="12" cy="12" r="8" /><path d="M12 8v4l3 2" /></svg>
);

export const ProductIcon = () => (
  <svg {...base}><path d="M4 8.5 12 4l8 4.5v7L12 20l-8-4.5v-7Z" /><path d="M4 8.5 12 13l8-4.5M12 13v7" /></svg>
);

export const CategoryIcon = () => (
  <svg {...base}><rect x="3.5" y="3.5" width="7" height="7" rx="1.5" /><path d="M14 4h6.5M14 7h6.5M14 17h6.5M14 20h6.5" /><rect x="3.5" y="13.5" width="7" height="7" rx="1.5" /></svg>
);

export const OrderIcon = () => (
  <svg {...base}><path d="M6 7h12l-1 12H7L6 7Z" /><path d="M9 7a3 3 0 0 1 6 0" /></svg>
);

export const StoreIcon = () => (
  <svg {...base}><path d="M4 9.5 5.5 4h13L20 9.5" /><path d="M4 9.5v10h16v-10" /><path d="M9 19.5v-6h6v6" /></svg>
);

export const TableOrderIcon = () => (
  <svg {...base}><rect x="3.5" y="6.5" width="17" height="11" rx="2" /><path d="M7 17.5v2M17 17.5v2M8 10.5h8" /></svg>
);

export const TableCallIcon = () => (
  <svg {...base}><path d="M4 10.5a8 8 0 0 1 16 0" /><path d="M2.5 10.5h2.2a1 1 0 0 1 1 1v3.4a1 1 0 0 1-1 1H2.5zM19.3 10.5h2.2v5.4h-2.2a1 1 0 0 1-1-1v-3.4a1 1 0 0 1 1-1z" /><path d="M4.7 15.9v1a3 3 0 0 0 3 3h2.6" /></svg>
);

export const ReservationIcon = () => (
  <svg {...base}><rect x="3.5" y="4.5" width="17" height="15" rx="2" /><path d="M3.5 9h17M8 3v3M16 3v3" /><circle cx="15.5" cy="15" r="3" /><path d="M15.5 13.5V15l1 .8" /></svg>
);

export const LogoutIcon = () => (
  <svg {...base}><path d="M9 4H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3" /><path d="M14 8l4 4-4 4M18 12H9" /></svg>
);

export const ReviewIcon = () => (
  <svg {...base}><path d="m12 4 2.3 4.7 5.2.8-3.75 3.65.9 5.15L12 15.9l-4.65 2.4.9-5.15L4.5 9.5l5.2-.8Z" /></svg>
);

export const BannerIcon = () => (
  <svg {...base}><rect x="3" y="5" width="18" height="11" rx="1.5" /><path d="m3 13 4.5-3.5 3 2.3L16 8l5 4" /><path d="M8 19h8" /></svg>
);

export const OrderDiscountIcon = () => (
  <svg {...base}><path d="M4 12 12 4l8 8-8 8-8-8Z" /><circle cx="9.5" cy="9.5" r="1.4" /><path d="m9 15 6-6" /></svg>
);
